import { useQuery } from '@gogame/query';

import { loadActionsLogs } from 'scenes/SpendAdjustments/sources/spendAdjustment';

import { logs } from './queryKeyFactory';

export const useLoadSALogs = (id) => {
  return useQuery(
    logs(id),
    (_, { signal }) => loadActionsLogs({ id }, { signal }),
    {}
  );
};
